<template>
  <div>
    <img src="../assets/my/2025.png" style="height:120px;"/>
    	<div id="wrapper">
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Registration
    				</strong>
    			</p>

    			
             <p>Online registration refer to <a href="https://biod.whu.edu.cn/bibm2025/">main conference</a>.</p>
    		</div>
    	</div>
      <footer-component></footer-component>
      
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
